import { render } from "./CustomFieldCreatePage.vue?vue&type=template&id=38a15760"
import script from "./CustomFieldCreatePage.vue?vue&type=script&lang=js"
export * from "./CustomFieldCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__